import { colors } from '@lmc/common/constants'
import PropTypes from 'prop-types'
import React from 'react'
import { LabelIcon } from '../../../../../components/generic'
import {
  getIconFill,
  getTextFill
} from '../../../utils/medicationRoundsRowUtils'

const renderSigned = (props) => {
  const { signed } = props

  return (
    <div style={styles.signedContainer}>
      <div style={styles.signed}>
        <LabelIcon
          boldText={signed}
          iconName={'tick-in-circle'}
          iconFill={getIconFill(signed, colors.successgreen)}
          iconSize={20}
          text={'Signed'}
          textFill={getTextFill(signed)}
        />
      </div>
    </div>
  )
}

const renderDue = (props) => {
  const { due } = props

  return (
    <div style={styles.dueContainer}>
      <div style={styles.due}>
        <LabelIcon
          boldText={due}
          iconName={'clock'}
          iconFill={getIconFill(due, colors.yellow)}
          iconSize={20}
          text={'Due'}
          textFill={getTextFill(due)}
        />
      </div>
    </div>
  )
}

const renderNotSigned = (props) => {
  const { notSigned } = props

  return (
    <div style={styles.notSignedContainer}>
      <div style={styles.notSigned}>
        <LabelIcon
          boldText={notSigned}
          iconName={'overdue'}
          iconFill={getIconFill(notSigned, colors.red)}
          iconSize={20}
          text={'Not signed'}
          textFill={getTextFill(notSigned)}
        />
      </div>
    </div>
  )
}

/**
@description Renders a status column cell.

@param {number} due. The residents whose meds are due (i.e. not signed).
If a round is the most recent round, the residents will be counted as due.
If a round is not the most recent round, the residents will be counted as
not signed.

@param {number} notSigned. The residents whose meds have not been signed.
These will be meds that are due, but are in rounds in the past, excluding
the most recent round.

@param {number} signed. The residents whose meds have been signed for
(either given or not given).

@returns {function} StatusColumnCell
*/

export default function StatusColumnCell(props) {
  return (
    <div style={styles.statusColumn}>
      {renderSigned(props)}
      {renderDue(props)}
      {renderNotSigned(props)}
    </div>
  )
}

StatusColumnCell.propTypes = {
  due: PropTypes.number.isRequired,
  notSigned: PropTypes.number.isRequired,
  signed: PropTypes.number.isRequired
}

const styles = {
  due: {
    height: 22,
    width: 120
  },
  dueContainer: {
    flexGrow: 1
  },
  notSigned: {
    height: 22,
    width: 150
  },
  notSignedContainer: {
    flexGrow: 4
  },
  signed: {
    height: 22,
    width: 120
  },
  signedContainer: {
    flexGrow: 1
  },
  statusColumn: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    lineHeight: '22px',
    width: 450
  }
}
